import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertTypeEnum } from './AlertTypeEnum';

export interface AlertState {
  open: boolean;
  type: AlertTypeEnum;
  title: string;
  body: string;
}

const initialState: AlertState = {
  open: false,
  type: AlertTypeEnum.SUCCESS,
  title: '',
  body: '',
};

const descriptionAlertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    open: (state: AlertState, action: PayloadAction<AlertState>) => {
      state.open = true;
      state.type = action.payload.type;
      state.title = action.payload.title;
      state.body = action.payload.body;
    },
    close: (state: AlertState) => {
      state.open = false;
    },
  },
});

export default descriptionAlertSlice;
